import type { ConsumerProfileResponse } from "../components/features/sendmoney/models/profileSearch";
import type { CountryResponse } from "../components/features/sendmoney/models/countryResponse";
import type { QuoteRequest } from "../components/features/sendmoney/models/quoteRequest";
import type { QuoteResponse } from "../components/features/sendmoney/models/quoteResponse";
import type { TransactionFieldsSendResponse } from "../components/features/sendmoney/models/transactionFieldsSendResponse";
import type { UpdateTransactionRequest } from "../components/features/sendmoney/models/updateTransactionRequest";
import { API_ENDPOINTS, getTransactionalApiUrl } from "../config";
import { buildBffRequestHeaders } from "./bffRequestHeaders";
import { TransactionFieldsSendRequest } from "../components/features/sendmoney/models/transactionFieldsSendRequest";

class SendMoneyService {
  async loadCountries(): Promise<CountryResponse> {
    const url = getTransactionalApiUrl(API_ENDPOINTS.MAPI_COUNTRIES);
    const response = await fetch(url, {
      method: "GET",
      headers: buildBffRequestHeaders(),
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data?.message || `Failed to load countries (${response.status})`
      );
    }

    return {
      countries: Array.isArray(data.data) ? data.data : [],
    };
  }

  async getQuote(params: QuoteRequest): Promise<QuoteResponse> {
    const url = getTransactionalApiUrl(API_ENDPOINTS.MAPI_QUOTE);
    const response = await fetch(url, {
      method: "POST",
      headers: buildBffRequestHeaders(),
      body: JSON.stringify(params),
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data?.message || `Failed to get quote (${response.status})`
      );
    }

    return data.data as QuoteResponse;
  }

  async transactionFieldsSend(
    params: TransactionFieldsSendRequest
  ): Promise<TransactionFieldsSendResponse> {
    const url = getTransactionalApiUrl(API_ENDPOINTS.MAPI_TRANSACTION_FIELDS_SEND);
    const response = await fetch(url, {
      method: "POST",
      headers: buildBffRequestHeaders(),
      body: JSON.stringify(params),
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data?.message || `Failed to load transaction fields (${response.status})`
      );
    }

    return data.data as TransactionFieldsSendResponse;
  }

  async updateTransaction(params: UpdateTransactionRequest): Promise<unknown> {
    const url = getTransactionalApiUrl(API_ENDPOINTS.MAPI_UPDATE_TRANSACTION);
    const response = await fetch(url, {
      method: "PUT",
      headers: buildBffRequestHeaders(),
      body: JSON.stringify(params),
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data?.message || `Failed to update transaction (${response.status})`
      );
    }

    return data;
  }

  async lookupConsumer(phoneNumber: string): Promise<ConsumerProfileResponse> {
    return {
      profiles: [
        {
          name: {
            firstName: "Sathya",
            lastName: "Srinivas",
          },
          address: {
            line1: "123 test",
            city: "city",
            countrySubdivisionCode: "US-AZ",
            countryCode: "USA",
            postalCode: "45612",
          },
          mobilePhone: {
            number: phoneNumber,
            countryDialCode: "1",
          },
          dateOfBirth: "1985-12-12",
          profileID: "99aa7a05-8dd8-450a-b51a-6a118cf7879c",
        },
      ],
    };
  }
}

export const sendMoneyService = new SendMoneyService();
